import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { WarningIcon } from "../Icons/Warning";
import { useAlert } from "../../context/AlertContext";
import { fetcher } from "../../utils/fetcher";
import { AccountType } from "@/pages/Register";

interface RemoveAccountDialogProps {
  id: string;
  accountType: AccountType;
  dialogOpen: boolean;
  setDialogOpen: (open: boolean) => void;
  onSuccessCallback?: () => void;
}

export const RemoveAccountDialog = ({
  id,
  accountType,
  dialogOpen,
  setDialogOpen,
  onSuccessCallback,
}: RemoveAccountDialogProps) => {
  const { setAlert } = useAlert();

  const handleAccountDelete = async () => {
    if (!id) return;

    const url =
      accountType === "volunteer" ? `/volunteer/${id}` : `/organisation/${id}`;

    try {
      await fetcher({
        url: url,
        method: "DELETE",
      });
      setAlert(true, "success", "Váš účet byl úspěšně zrušen.");
      if (onSuccessCallback) {
        onSuccessCallback();
      }
    } catch (error) {
      setAlert(
        true,
        "error",
        "Zrušení účtu se nezdařilo, zkuste to prosím znovu později nebo nás kontaktujte.",
      );
      console.error("Error removing account:", error);
    } finally {
      setDialogOpen(false);
    }
  };

  return (
    <>
      <Dialog
        open={dialogOpen}
        onClose={() => {
          setDialogOpen(false);
        }}
        aria-labelledby="cancel-dialog-title"
        aria-describedby="cancel-dialog-description"
        maxWidth="xs"
      >
        <DialogTitle id="cancel-dialog-title">
          <WarningIcon />
          Opravdu si přejete zrušit svůj účet?
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="cancel-dialog-description">
            {accountType === "volunteer"
              ? "Tato akce je nevratná. Všechny vaše údaje budou smazány a nebudete mít přístup ke svému účtu. Rovněž budete odhlášeni ze všech případných akcí, na které jste se přihlásili."
              : "Tato akce je nevratná. Všechny údaje vaší organizace budou smazány a nebudete mít přístup ke svému účtu."}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            variant="outlined"
            color="inherit"
            fullWidth
            onClick={() => {
              setDialogOpen(false);
            }}
          >
            Ne, nerušit
          </Button>
          <Button
            variant="contained"
            fullWidth
            color="error"
            onClick={() => handleAccountDelete()}
          >
            Ano, zrušit
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
